module.exports = __webpack_public_path__ + "img/relaxgaming.cd2421dd.svg";